import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { createContext, useContext } from 'react';
import styled from '@emotion/styled';
import { getStyle } from './utils.es.js';
import { P as PbDivider } from './PbDivider-c33bf61b.js';
import { g as getIconCompoment } from './common-dbaafe9f.js';
import '@teko-builder/types/pb';

const ListContext = createContext({});

const StyleUl = styled.ul(({ commonStyle }) => `
  ${getStyle(commonStyle)}
  display: flex;
  flex-direction: column;
  list-style: none;
`);
const List = React.forwardRef((_a, ref) => {
    var { children, commonStyle } = _a, rest = __rest(_a, ["children", "commonStyle"]);
    const { contentStyle, divider, dividerStyle, icon, iconStyle, content, itemStyle, } = rest;
    return (jsx(ListContext.Provider, Object.assign({ value: {
            contentStyle,
            divider,
            dividerStyle,
            icon,
            iconStyle,
            content,
            itemStyle,
        } }, { children: jsx(StyleUl, Object.assign({ commonStyle: commonStyle, ref: ref }, rest, { children: children })) })));
});
List.displayName = 'List';

const StyledLi = styled.li(({ commonStyle, itemStyle }) => `
  display: flex;
  align-items: center;
  max-width: 100%;
  ${getStyle(itemStyle)}
  ${getStyle(commonStyle)}
`);
const StyledPbDivider = styled(PbDivider) `
  &:last-child {
    display: none;
  }
`;
const ListItem = React.forwardRef(({ children, commonStyle, lastItem = false }, ref) => {
    const { divider, dividerStyle, itemStyle } = useContext(ListContext);
    return (jsxs(Fragment, { children: [jsx(StyledLi, Object.assign({ commonStyle: commonStyle, ref: ref, itemStyle: itemStyle }, { children: children })), !!divider && !lastItem && (jsx(StyledPbDivider, Object.assign({}, divider, { commonStyle: dividerStyle })))] }));
});
ListItem.displayName = 'ListItem';

const StyledIcon = styled.span(({ commonStyle, iconStyle }) => `
  display: flex;
  ${getStyle(iconStyle)}
  ${getStyle(commonStyle)}
`);
const ListItemIcon = React.forwardRef(({ commonStyle, icon: realIcon }, ref) => {
    const { icon, iconStyle } = useContext(ListContext);
    const GlobalIcon = getIconCompoment(icon);
    const IconComponent = getIconCompoment(realIcon);
    return (jsx(StyledIcon, Object.assign({ ref: ref, commonStyle: commonStyle, iconStyle: iconStyle }, { children: IconComponent || GlobalIcon })));
});
ListItemIcon.displayName = 'ListItemIcon';

const StyledListItemContent = styled.div(({ commonStyle, contentStyle, }) => `
    ${getStyle(contentStyle)}
    ${getStyle(commonStyle)}
  `);
const ListItemContent = React.forwardRef((props, ref) => {
    const { text, children } = props, rest = __rest(props, ["text", "children"]);
    const { contentStyle } = useContext(ListContext);
    if (!!children) {
        return (jsx(StyledListItemContent, Object.assign({ ref: ref }, rest, { contentStyle: contentStyle }, { children: children })));
    }
    return (jsx(StyledListItemContent, Object.assign({ ref: ref }, rest, { contentStyle: contentStyle, dangerouslySetInnerHTML: { __html: text } })));
});
ListItemContent.displayName = 'ListItemContent';

export { List as L, StyledListItemContent as S, ListItem as a, ListItemIcon as b, ListItemContent as c };
